import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
    ? process.env.REACT_APP_API_BASE_URL
    : "";
export const baseAPI = api(baseEndpoint);

const transactionService =  {
    getTransactionHistory: async () => {
        return baseAPI.post(`/Mobile/SelfService/TransactionHistory`);
    },
};

export default transactionService;